const ConfigGeneral={
    "inicio":{
        "categoria_productos":{
            "capa":"superfamilia"
        }
    }
}

export default ConfigGeneral;
